import React, { useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Table,
  Input,
  Button,
  Label,
  InputGroup,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

// Redux
import { getDaily } from "connection/backend";
import { get_file } from "connection/api";

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { Spanish } from "flatpickr/dist/l10n/es";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

const Daily = () => {
  const URL = process.env.REACT_APP_URL;
  const [loading, setLoading] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [createdDateRange, setCreatedDateRange] = useState([]);
  const [search, setSearch] = useState("");
  const [animals, setAnimals] = useState(0);
  const [total, setTotal] = useState(0);

  const onChange1 = (e) => {
    setSearch(e.target.value);
  };

  const onChange2 = (createdDateRange) => {
    setCreatedDateRange(createdDateRange);
  };

  const onClick = async () => {
    const date_1 = createdDateRange[0]
      ? createdDateRange[0].toISOString().slice(0, 10)
      : "";
    const date_2 = createdDateRange[1]
      ? createdDateRange[1].toISOString().slice(0, 10)
      : "";
    const excel_url = `${URL}report/diario_excel/?client_code=${search}&created_date_after=${date_1}&created_date_before=${date_2}`;
    try {
      const response = await get_file(excel_url);
      const blob = new Blob([response.data], {
        type: "application/vnd.ms-excel",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `BalanceDiario_${date_1}_${date_2}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error("Error al descargar el archivo", error);
    }
  };

  const resetFilter = () => {
    setSearch("");
    setCreatedDateRange("");
    setTickets([]);
    setAnimals(0);
    setTotal(0);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const date_1 = createdDateRange[0]
      ? createdDateRange[0].toISOString().slice(0, 10)
      : "";
    const date_2 = createdDateRange[1]
      ? createdDateRange[1].toISOString().slice(0, 10)
      : "";
    let url = `?client_code=${search}&created_date_after=${date_1}&created_date_before=${date_2}`;
    getData(url);
  };

  const getData = async (url) => {
    setLoading(true);
    const response = await getDaily(url);
    setTickets(response.data.tickets);
    setAnimals(response.data.animals);
    setTotal(response.data.total);
    setLoading(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Reportes </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Reportes"} />
          {loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              <Card
                style={{
                  width: "75rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-3 font-size-20">Balance diario</h2>
                </CardTitle>
                <CardBody>
                  <Form onSubmit={onSubmit}>
                    <Row className="justify-content-md-start">
                      <Col lg={3}>
                        <p className="mb-1 font-size-13">Fecha:</p>
                        <InputGroup>
                          <Flatpickr
                            className="form-control"
                            placeholder="dd/mm/aaaa"
                            value={createdDateRange}
                            onChange={onChange2}
                            options={{
                              mode: "range",
                              dateFormat: "d/m/Y",
                              locale: Spanish,
                            }}
                          />
                        </InputGroup>
                      </Col>
                      <Col lg={3} className="search-box mt-4">
                        <InputGroup>
                          <Input
                            type="text"
                            className="form-control"
                            name="search"
                            id="search"
                            value={search}
                            onChange={onChange1}
                            placeholder="Código cliente..."
                          />
                          <i className="bx bx-search-alt search-icon" />
                          <Button color="primary" onClick={resetFilter}>
                            <span className=" bx bx-x fa-lg align-middle"></span>
                          </Button>
                        </InputGroup>
                      </Col>
                      <Col lg={6} className="mt-4">
                        <Button color="primary" type="submit">
                          Consultar
                        </Button>
                        {tickets.length > 0 && (
                          <Button
                            className="ms-2"
                            color="success"
                            type="button"
                            onClick={onClick}
                          >
                            Exportar
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </Form>
                  <Row className="justify-content-md-center mt-2 mb-2">
                    <Col lg={12}>
                      <hr />
                    </Col>
                  </Row>
                  {tickets.length > 0 ? (
                    <>
                      <Table
                        className="table table-striped table-borderless align-middle table-centered table-nowrap mb-4"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <thead className="table-light">
                          <tr>
                            <th>Código cliente</th>
                            <th>Ticket</th>
                            <th>Fecha ingreso</th>
                            <th>Cantidad bovinos</th>
                            <th>Valor unitario</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tickets.map((ticket, idx) => (
                            <tr key={idx}>
                              <th scope="row">{ticket.client}</th>
                              <td>{ticket.ticket}</td>
                              <td>{ticket.created_date}</td>
                              <td>{ticket.animal_number}</td>
                              <td>$ {ticket.rate.toLocaleString("es-CO")}</td>
                              <td>$ {ticket.total.toLocaleString("es-CO")}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <Row className="justify-content-md-start">
                        <Col lg={3}>
                          <label>
                            <b>Total bovinos:</b> {animals}
                          </label>
                        </Col>
                        <Col lg={3}>
                          <label>
                            <b>Total:</b> $ {total.toLocaleString("es-CO")}
                          </label>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <h3 className="card-title mb-4">
                        No se encontraron resultados
                      </h3>
                      <Row className="justify-content-md-start">
                        <Col lg={3}>
                          <label>
                            <b>Total bovinos:</b> {animals}
                          </label>
                        </Col>
                        <Col lg={3}>
                          <label>
                            <b>Total:</b> $ {total.toLocaleString("es-CO")}
                          </label>
                        </Col>
                      </Row>
                    </>
                  )}
                </CardBody>
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Daily;
